import React, { ReactNode, useState } from 'react';
import uniqid from 'uniqid';
import './QcmQuestion.scss';

interface Props {
  title: string;
  options?: Array<{
    label?: string;
    name: string;
  }>;
  info?: ReactNode | string;
  defaultValue?: string;
  onChange?: (value: string) => any;
}

export const QcmQuestion: React.FC<Props> = ({
  title,
  options = [
    { label: 'Oui', name: 'oui' },
    { label: 'Non', name: 'non' }
  ],
  info,
  defaultValue,
  onChange = () => {}
}) => {
  const [value, setValue] = useState<string | undefined>(defaultValue);
  const [id] = useState(uniqid('qcm-'));

  function _onChange(value: string) {
    setValue(value);
    onChange(value);
  }

  return (
    <div className="qcm">
      <h2 className="qcm__title">{title}</h2>
      <div className="qcm__questions">
        {options.map((option) => (
          <div className="qcm__question" key={option.name}>
            <div className="qcm__question__inner">
              <input
                id={id + option.name}
                type="radio"
                name={id}
                value={option.name}
                checked={value === option.name}
                onChange={() => {}}
                onClick={(e) => _onChange(option.name)}
                className="qcm__input"
              />
              <label
                htmlFor={id + option.name}
                className={`qcm__label ${
                  (option.label || option.name).length > 5
                    ? 'qcm__label--long'
                    : ''
                }`}
              >
                <span className="qcm__label__inner">
                  {option.label || option.name}
                </span>
              </label>
            </div>
          </div>
        ))}
      </div>
      {info && <p className="qcm__info">{info}</p>}
    </div>
  );
};
